"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepIcon = void 0;
var tslib_1 = require("tslib");
var Stepper_style_1 = require("./Stepper.style");
var RadioButtonUnchecked_1 = tslib_1.__importDefault(require("@material-ui/icons/RadioButtonUnchecked"));
var CheckCircleOutline_1 = tslib_1.__importDefault(require("@material-ui/icons/CheckCircleOutline"));
var react_1 = tslib_1.__importDefault(require("react"));
var StepIcon = function (props) {
    var classes = (0, Stepper_style_1.useStepperStyles)();
    var active = props.active, completed = props.completed;
    return (react_1.default.createElement("div", null,
        active && (react_1.default.createElement(RadioButtonUnchecked_1.default, { color: "primary", classes: { root: classes.iconRoot, colorPrimary: classes.iconCompleted } })),
        completed && !active && (react_1.default.createElement(CheckCircleOutline_1.default, { color: "primary", classes: { root: classes.iconRoot, colorPrimary: classes.iconCompleted } })),
        !active && !completed && react_1.default.createElement(RadioButtonUnchecked_1.default, { classes: { root: classes.iconRoot } })));
};
exports.StepIcon = StepIcon;
